import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8 0C3.58204 0 0 3.57926 0 7.99518C0 12.4111 3.58205 15.9902 8 15.9902C9.39302 15.9902 11.1038 15.6404 12.3245 14.9808L15.2994 15.9633C15.4911 16.0266 15.702 15.9763 15.8445 15.8333C15.9869 15.6904 16.0365 15.4792 15.9725 15.2878L14.9841 12.3316C15.7019 11.081 16 9.445 16 7.99518C16 3.57926 12.418 0 8 0Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8 0C3.58204 0 0 3.57926 0 7.99518C0 12.4111 3.58205 15.9902 8 15.9902C9.39302 15.9902 11.1038 15.6404 12.3245 14.9808L15.2994 15.9633C15.4911 16.0266 15.702 15.9763 15.8445 15.8333C15.9869 15.6904 16.0365 15.4792 15.9725 15.2878L14.9841 12.3316C15.7019 11.081 16 9.445 16 7.99518C16 3.57926 12.418 0 8 0Z",
  fill: "currentColor"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ChatsIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "chats",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }))
}
}

})